/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import {
  IDadosGraficosPesquisaModel,
  IGraficoDispersaoDimensaoModel,
  IGraficoDispersaoTipoModel,
} from '../helpers/AnaliseResultadoHelper'

type Props = {
  showModal: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  dimensaoIndex: number | undefined
  dispersaoIndex: number | undefined
  fillColor: string | undefined
  dadosGraficosPesquisa: IDadosGraficosPesquisaModel | undefined
}

const ModalGraficoDispersao = ({
  showModal,
  setShowModal,
  dimensaoIndex,
  dispersaoIndex,
  fillColor,
  dadosGraficosPesquisa,
}: Props) => {
  const [dimensao, setDimensao] = useState<IGraficoDispersaoDimensaoModel | undefined>(undefined)
  const [dispersao, setDispersao] = useState<IGraficoDispersaoTipoModel | undefined>(undefined)
  const [qTDPessoa, setQTDPessoa] = useState<number>(0)
  const [qTDPesquisaTotal, setQTDTotalPesquisa] = useState<number>(0)
  const [porcentagem, setPorcentagem] = useState<number>(0)

  const [percentuaisPerguntas, setPercentuaisPerguntas] = useState<Record<number, string>>({})

  useEffect(() => {
    if (!dadosGraficosPesquisa) return

    const idsFinalizados = new Set(dadosGraficosPesquisa.Participantes.map(p => p.Id))

    const idsUnicosPesquisa = new Set<number>()
    dadosGraficosPesquisa.GraficoDispersao?.Dimensoes?.forEach(dim => {
      dim.Dispersoes.forEach(disp => {
        disp.Perguntas.forEach(perg => {
          perg.IdsParticipantes.forEach(id => {
            if (idsFinalizados.has(id)) {
              idsUnicosPesquisa.add(id)
            }
          })
        })
      })
    })

    const totalFinalizadosPesquisa = idsUnicosPesquisa.size
    setQTDTotalPesquisa(totalFinalizadosPesquisa)

    if (dimensaoIndex !== undefined && dispersaoIndex !== undefined) {
      const dimensaoAtual = dadosGraficosPesquisa.GraficoDispersao.Dimensoes[dimensaoIndex]
      setDimensao(dimensaoAtual)

      const dispersaoAtual = dimensaoAtual.Dispersoes[dispersaoIndex]
      setDispersao(dispersaoAtual)

      if (dispersaoAtual?.Perguntas) {
        const idsUnicosDispersao = new Set<number>()
        dispersaoAtual.Perguntas.forEach(pergunta => {
          pergunta.IdsParticipantes.forEach(id => {
            if (idsFinalizados.has(id)) {
              idsUnicosDispersao.add(id)
            }
          })
        })

        const totalPessoasDispersao = idsUnicosDispersao.size
        const porcentagemRespondida =
          totalFinalizadosPesquisa > 0
            ? (totalPessoasDispersao / totalFinalizadosPesquisa) * 100
            : 0

        setQTDPessoa(totalPessoasDispersao)
        setPorcentagem(porcentagemRespondida)

        
        const mapaPerguntas = new Map<number, number>()
        let somaTotalRespondentes = 0

        dispersaoAtual.Perguntas.forEach(pergunta => {
          const respondentesUnicos = new Set<number>()
          pergunta.IdsParticipantes.forEach(id => {
            if (idsFinalizados.has(id)) {
              respondentesUnicos.add(id)
            }
          })

          mapaPerguntas.set(pergunta.Id, respondentesUnicos.size)
          somaTotalRespondentes += respondentesUnicos.size
        })

        const percentuais: Record<number, string> = {}
        mapaPerguntas.forEach((valor, chave) => {
        const percentual =
          somaTotalRespondentes > 0
            ? (valor / somaTotalRespondentes) * 100
            : 0
          percentuais[chave] = percentual.toFixed(2)
        })

        setPercentuaisPerguntas(percentuais)
      }
    }
  }, [dadosGraficosPesquisa, dispersaoIndex, dimensaoIndex])

  const valorDispersaoSelecionada = dadosGraficosPesquisa?.GraficoDispersao.Series
  ?.find((serie) => serie.tipo === dispersao?.Tipo)
  ?.data?.[dimensaoIndex ?? 0] ?? 0;

  return (
    <div
      className={`modal ${showModal && dimensaoIndex !== undefined && dispersaoIndex !== undefined && fillColor !== undefined ? 'show' : ''} fade`}
      tabIndex={-1}
      id='kt_modal_1'
      style={{
        display: `${showModal && dimensaoIndex !== undefined && dispersaoIndex !== undefined && fillColor !== undefined ? 'block' : 'none'}`,
      }}
    >
      <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl'>
        <div className='modal-content border border-1' style={{ borderColor: fillColor + ' !important' }}>
          <div className='modal-header d-flex align-items-center' style={{ backgroundColor: fillColor }}>
            <h3 className='modal-title mb-0'>{`${dispersao?.Nome ?? ''}: ${dimensao?.Nome ?? ''}`}</h3>

            <div className='d-flex align-items-center gap-2 ms-auto'>
              <span className='badge-value'>
                {`${valorDispersaoSelecionada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`}
              </span>
            </div>

            <div
              onClick={() => setShowModal(false)}
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Fechar'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
            </div>
          </div>

          <div className='modal-body'>
            {dispersao &&
              dispersao.Perguntas.map((pergunta, perguntaIndex) => {
                const respondentesUnicos = new Set<number>()
                const idsFinalizados = new Set(dadosGraficosPesquisa?.Participantes.map(p => p.Id))
                pergunta.IdsParticipantes.forEach(id => {
                  if (idsFinalizados.has(id)) {
                    respondentesUnicos.add(id)
                  }
                })

                const totalRespostas = respondentesUnicos.size
                const percentual = percentuaisPerguntas[pergunta.Id] || '0.00'

                return (
                  <div
                    key={`accordion-pergunta-${pergunta.Id}`}
                    className={`w-100 ${perguntaIndex < (dispersao?.Perguntas.length ?? 1) - 1 ? 'mb-8' : ''}`}
                  >
                    <div className='card card-custom card-pergunta border border-secondary border-1 shadow-sm dimensao-pesquisa-nao-selecionado'>
                      <div
                        className='card-header border-bottom border-secondary border-1 rounded-bottom flex-nowrap'
                        style={{ backgroundColor: 'rgba(218, 218, 217, 1)' }}
                      >
                        <div className='card-title w-100 d-flex justify-content-between'>
                          <h5 className='mb-0'>{pergunta.Texto}</h5>
                          <div className='d-flex align-items-center gap-2'>
                            <span className='badge-value'>{`${totalRespostas}`}</span>
                            <span className='badge-value'>
                              {`${parseFloat(percentual).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`}
                            </span>
                          </div>
                        </div>
                        <div className='card-toolbar w-md-auto'>
                          <button
                            type='button'
                            className='btn btn-icon btn-sm btn-accordion btn-light'
                            data-bs-toggle='collapse'
                            data-bs-target={`#card-pergunta-collapse-${pergunta.Id}`}
                            aria-expanded='false'
                            aria-controls={`card-pergunta-collapse-${pergunta.Id}`}
                          >
                            <i className='fas fa-arrow-down'></i>
                            <i className='fas fa-arrow-up'></i>
                          </button>
                        </div>
                      </div>
                      <div
                        id={`card-pergunta-collapse-${pergunta.Id}`}
                        className='collapse'
                        data-bs-parent={`#accordion-pergunta-${pergunta.Id}`}
                      >
                        <div className='card-body w-100'>
                          {dadosGraficosPesquisa && pergunta.IdsParticipantes.length > 0 ? (
                            pergunta.IdsParticipantes.map(idParticipante => {
                              const participante = dadosGraficosPesquisa.Participantes.find(p => p.Id === idParticipante)
                              return (
                                <div
                                  key={`grafico-dispersao-${dispersaoIndex}-pergunta-${perguntaIndex}-participante-${idParticipante}`}
                                  className='my-5'
                                >
                                  <div className='menu-content d-flex align-items-center px-3'>
                                    <div className='symbol symbol-75px me-5'>
                                      <img
                                        alt='Foto'
                                        src={participante?.FotoDataUrl ?? toAbsoluteUrl('/media/avatars/blank.png')}
                                      />
                                    </div>
                                    <div className='d-flex flex-column'>
                                      <div className='fw-bolder fs-5 mb-1'>{participante?.Nome}</div>
                                      <div className='fw-bold text-muted text-hover-primary fs-7 mb-1'>{participante?.Email}</div>
                                      <div className='fw-bold text-muted fs-7'>{participante?.NomeCargo}</div>
                                    </div>
                                  </div>
                                </div>
                              )
                            })
                          ) : (
                            <h2 className='text-center m-0 p-0'>
                              Essa pergunta não possui {dispersao?.Nome.toLowerCase()}
                            </h2>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
          </div>

          <div className='modal-footer d-flex justify-content-end'>
            <button onClick={() => setShowModal(false)} type='button' className='btn btn-light' data-bs-dismiss='modal'>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ModalGraficoDispersao }
